var _defs, _g, _g2, _g3, _g4, _g5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOverarchinggoalslogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1080,
    zoomAndPan: "magnify",
    viewBox: "0 0 810 809.999993",
    height: 1080,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "c4a38fa945"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 81 110.59375 L 729 110.59375 L 729 699.742188 L 81 699.742188 Z M 81 110.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "62151d1ed2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 148.5 110.59375 L 661.5 110.59375 C 698.777344 110.59375 729 140.816406 729 178.09375 L 729 631.90625 C 729 669.183594 698.777344 699.40625 661.5 699.40625 L 148.5 699.40625 C 111.222656 699.40625 81 669.183594 81 631.90625 L 81 178.09375 C 81 140.816406 111.222656 110.59375 148.5 110.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e670b61a7a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 168.984375 511.734375 L 640.125 511.734375 L 640.125 585.652344 L 168.984375 585.652344 Z M 168.984375 511.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "efb47369ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 180.207031 511.734375 L 628.828125 511.734375 C 635.027344 511.734375 640.050781 516.691406 640.050781 522.808594 L 640.050781 574.578125 C 640.050781 580.695312 635.027344 585.652344 628.828125 585.652344 L 180.207031 585.652344 C 174.007812 585.652344 168.984375 580.695312 168.984375 574.578125 L 168.984375 522.808594 C 168.984375 516.691406 174.007812 511.734375 180.207031 511.734375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6a09f87419"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 196.722656 456.808594 L 612.429688 456.808594 L 612.429688 521.484375 L 196.722656 521.484375 Z M 196.722656 456.808594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c997e73cd2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 207.945312 456.808594 L 601.203125 456.808594 C 607.402344 456.808594 612.429688 461.875 612.429688 468.125 L 612.429688 510.171875 C 612.429688 516.421875 607.402344 521.484375 601.203125 521.484375 L 207.945312 521.484375 C 201.746094 521.484375 196.722656 516.421875 196.722656 510.171875 L 196.722656 468.125 C 196.722656 461.875 201.746094 456.808594 207.945312 456.808594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "96530840ae"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 224.496094 400.984375 L 584.800781 400.984375 L 584.800781 465.664062 L 224.496094 465.664062 Z M 224.496094 400.984375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c719e84819"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 235.722656 400.984375 L 573.539062 400.984375 C 579.738281 400.984375 584.765625 406.050781 584.765625 412.300781 L 584.765625 454.347656 C 584.765625 460.597656 579.738281 465.664062 573.539062 465.664062 L 235.722656 465.664062 C 229.523438 465.664062 224.496094 460.597656 224.496094 454.347656 L 224.496094 412.300781 C 224.496094 406.050781 229.523438 400.984375 235.722656 400.984375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e5b4c93ee7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 318 228 L 493 228 L 493 395 L 318 395 Z M 318 228 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6cb653d21a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 407.921875 230.328125 L 425.078125 283.066406 C 426.464844 287.335938 430.453125 290.222656 434.953125 290.222656 L 490.4375 290.222656 C 491.5 290.222656 492.445312 290.90625 492.773438 291.914062 C 493.101562 292.921875 492.742188 294.027344 491.882812 294.652344 L 446.988281 327.238281 C 443.347656 329.878906 441.824219 334.554688 443.214844 338.824219 L 460.367188 391.5625 C 460.695312 392.570312 460.335938 393.671875 459.476562 394.292969 C 458.617188 394.917969 457.453125 394.914062 456.59375 394.292969 L 411.695312 361.707031 C 408.058594 359.066406 403.128906 359.066406 399.492188 361.707031 L 354.597656 394.292969 C 353.738281 394.914062 352.574219 394.917969 351.714844 394.292969 C 350.855469 393.671875 350.496094 392.570312 350.820312 391.5625 L 367.976562 338.824219 C 369.367188 334.554688 367.84375 329.878906 364.203125 327.238281 L 319.304688 294.652344 C 318.445312 294.027344 318.085938 292.921875 318.417969 291.914062 C 318.746094 290.90625 319.6875 290.222656 320.753906 290.222656 L 376.234375 290.222656 C 380.738281 290.222656 384.722656 287.335938 386.113281 283.066406 L 403.265625 230.328125 C 403.59375 229.320312 404.535156 228.640625 405.59375 228.640625 C 406.65625 228.640625 407.597656 229.320312 407.921875 230.328125 ",
    clipRule: "nonzero"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c4a38fa945)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#62151d1ed2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffd154",
    d: "M 81 110.59375 L 729 110.59375 L 729 699.109375 L 81 699.109375 Z M 81 110.59375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e670b61a7a)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#efb47369ac)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(3.073561, 0, 0, 3.032457, 168.98327, 511.735362)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 3.651712 -0.000325563 L 149.61304 -0.000325563 C 151.62999 -0.000325563 153.264393 1.634333 153.264393 3.651571 L 153.264393 20.723381 C 153.264393 22.740618 151.62999 24.375277 149.61304 24.375277 L 3.651712 24.375277 C 1.634762 24.375277 0.000359453 22.740618 0.000359453 20.723381 L 0.000359453 3.651571 C 0.000359453 1.634333 1.634762 -0.000325563 3.651712 -0.000325563 ",
    stroke: "#397da2",
    strokeWidth: 5.84446,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6a09f87419)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c997e73cd2)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(3.073791, 0, 0, 3.098281, 196.721127, 456.809373)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 3.651577 -0.000251516 L 131.590603 -0.000251516 C 133.607402 -0.000251516 135.242954 1.63498 135.242954 3.652227 L 135.242954 17.223261 C 135.242954 19.240508 133.607402 20.874479 131.590603 20.874479 L 3.651577 20.874479 C 1.634778 20.874479 0.000497447 19.240508 0.000497447 17.223261 L 0.000497447 3.652227 C 0.000497447 1.63498 1.634778 -0.000251516 3.651577 -0.000251516 ",
    stroke: "#397da2",
    strokeWidth: 5.84446,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#96530840ae)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c719e84819)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(3.073682, 0, 0, 3.098281, 224.498035, 400.986182)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 3.651849 -0.0005833 L 113.557961 -0.0005833 C 115.574832 -0.0005833 117.210441 1.634648 117.210441 3.651896 L 117.210441 17.222929 C 117.210441 19.240177 115.574832 20.875408 113.557961 20.875408 L 3.651849 20.875408 C 1.634978 20.875408 -0.000631443 19.240177 -0.000631443 17.222929 L -0.000631443 3.651896 C -0.000631443 1.634648 1.634978 -0.0005833 3.651849 -0.0005833 ",
    stroke: "#397da2",
    strokeWidth: 5.84446,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e5b4c93ee7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6cb653d21a)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "butt",
    transform: "matrix(3.100021, 0, 0, 3.090003, 313.204118, 223.169862)",
    fill: "none",
    strokeLinejoin: "miter",
    d: "M 30.553904 2.316587 L 36.08814 19.383974 C 36.535465 20.765698 37.821999 21.69991 39.273602 21.69991 L 57.171663 21.69991 C 57.514403 21.69991 57.81934 21.921138 57.925186 22.24729 C 58.031033 22.573443 57.915106 22.931199 57.63789 23.133465 L 43.155883 33.679064 C 41.981496 34.533635 41.490068 36.046831 41.938654 37.428555 L 47.47163 54.495941 C 47.577476 54.822094 47.461549 55.178586 47.184333 55.379587 C 46.907117 55.581853 46.531616 55.580588 46.2544 55.379587 L 31.771133 44.833988 C 30.598006 43.979417 29.007796 43.979417 27.834669 44.833988 L 13.352662 55.379587 C 13.075446 55.580588 12.699945 55.581853 12.422729 55.379587 C 12.145513 55.178586 12.029586 54.822094 12.134172 54.495941 L 17.668408 37.428555 C 18.116994 36.046831 17.625566 34.533635 16.451179 33.679064 L 1.967912 23.133465 C 1.690696 22.931199 1.57477 22.573443 1.681876 22.24729 C 1.787722 21.921138 2.091399 21.69991 2.435399 21.69991 L 20.3322 21.69991 C 21.785063 21.69991 23.070337 20.765698 23.518922 19.383974 L 29.051898 2.316587 C 29.157744 1.990435 29.461422 1.770471 29.802901 1.770471 C 30.145641 1.770471 30.449318 1.990435 30.553904 2.316587 ",
    stroke: "#397da2",
    strokeWidth: 5.84446,
    strokeOpacity: 1,
    strokeMiterlimit: 4
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverarchinggoalslogo);
export default __webpack_public_path__ + "static/media/overarchinggoalslogo.c55ae3b65646d3785a12253adbd6c1c6.svg";
export { ForwardRef as ReactComponent };